export default function ($sce, $log) {
  'ngInject';
  this.parseSolrData = function(data) {
    const returnObject = {};
    returnObject.records = [];
    
    if (typeof data === 'undefined') {
      returnObject.showResults = false;
    } else {
      returnObject.showResults = true;
    }
    
    returnObject.totalRecordsFound = data.totalRecordsFound;
    
    if (data.core.toUpperCase() == "WEB") {
      returnObject.spellcheck = data.spellcheck;
      returnObject.nextCursorMark = data.nextCursorMark;
      for (const i in data.records) {
          returnObject.records.push({
            summary: setSummary(data.records[i]),
            title: data.records[i].title,
            reference: setReference(data.records[i].url),
            url: data.records[i].url,
            site: data.records[i].site,
            newsType: data.records[i].newsType,
            icon: findIcon(data.records[i].url)
          });
      }
    }
    return returnObject;
  };
  
  this.parseOSSData = function (data) {
        const resultsOutput = [];
        /*
        if (parseInstructions === 'hits') {
            $log.log('received instruction to parse only oss hits');
            return `(${data.numFound})`;
        }
        */

        resultsOutput.showResults = true;
        for (const i in data.docs) {
            resultsOutput.push({
                summary: data.docs[i].txtSummary[0],
                title: data.docs[i].txtTitle[0],
                reference: `/knw/selfhelp/chat/secure/index.html#/${data.docs[i].domainId}/document/${data.docs[i].id}?hf=false&src=upSearch`
            });
        }
        resultsOutput.ossHits = `(${data.numFound})`;
        return resultsOutput;
    };
  
  // https://xdev.home.www.uprr.com/uit/ricola/pre3/docs/index.html#/icon
  function findIcon(url) {
    if (url.match(/(doc|docx)$/i)) {
      return "word-doc";
    }
    else if (url.match(/pdf$/i)) {
      return "document-pdf";
    }
    else if (url.match(/(ppt|pptx)$/i)) {
      return "ppt-doc";
    }
    else if (url.match(/(xls|xlsx)$/i)) {
      return "excel-doc";
    }
  }
  
  function setSummary(record) {
    let summary = "";
    if (record.description !== null && record.description.replace(/ /g, "") !== "") {
      summary = record.description;
    } else if (record.highlight !== null) {
      summary = record.highlight;
    } else {
      summary = record.content;
    }
    return summary;
  }
  
  function setReference(url) {
    let reference = "";
    
    if (url.indexOf("home.www.uprr.com") >= 0 || url.indexOf("employees.www.uprr.com") >= 0) {
      return url.replace(/^(?:\/\/|[^\/]+)*\//, '/');
    }
    return url;
  }
}



// WEBPACK FOOTER //
// ./src/search-interface/shared/services/parserService.js